import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'account-sku-categories' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
